if (!customElements.get('ly-main-product-form-time-counter')) {
    customElements.define('ly-main-product-form-time-counter', class extends HTMLElement {

        connectedCallback() {
            const targetTime = new Date(this.dataset.time) // 原始目标时间
            const now = new Date()

            if (isNaN(targetTime)) return

            // 计算目标时间，如果已过，则推进到当前所在的周期
            const finalTarget = this.getNextTargetTime(targetTime, now)
            this.startCountdown(finalTarget)
        }

        disconnectedCallback() {
            this.timer && clearInterval(this.timer)
        }

        getNextTargetTime(baseTime, now) {
            const WEEK_MS = 7 * 24 * 60 * 60 * 1000
            const diff = now.getTime() - baseTime.getTime()

            if (diff < 0) return baseTime // 目标时间还没到，直接用

            const weeksPassed = Math.floor(diff / WEEK_MS) + 1
            return new Date(baseTime.getTime() + weeksPassed * WEEK_MS)
        }

        startCountdown(targetTime) {
            const spans = this.querySelectorAll('.time-counter_t')

            const _update = () => {
                const now = Date.now()
                let diff = Math.max(0, targetTime - now)

                const seconds = Math.floor(diff / 1000) % 60
                const minutes = Math.floor(diff / (1000 * 60)) % 60
                const hours = Math.floor(diff / (1000 * 60 * 60)) % 24
                const days = Math.floor(diff / (1000 * 60 * 60 * 24))

                const values = [
                    this.pad(days),
                    ':',
                    this.pad(hours),
                    ':',
                    this.pad(minutes),
                    ':',
                    this.pad(seconds)
                ]

                spans.forEach((el, idx) => {
                    if (el.textContent !== values[idx]) {
                        el.textContent = values[idx]
                    }
                })

                if (diff <= 0) {
                    const nextTarget = this.getNextTargetTime(targetTime, new Date())
                    this.startCountdown(nextTarget)
                    return
                }
            }

            this.timer = setInterval(_update, 1000)
            _update()
        }

        pad(n) {
            return n < 10 ? '0' + n : String(n)
        }
    })
}